
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.848 9.561a8.039 8.039 0 000-3.122l-3.924.776a4 4 0 00-3.139-3.139L9.561.152a8.04 8.04 0 00-3.122 0l.776 3.924a3.987 3.987 0 00-1.435.595L3.555 1.347a8.044 8.044 0 00-2.208 2.208L4.671 5.78a3.987 3.987 0 00-.595 1.435L.152 6.439a8.04 8.04 0 000 3.122l3.924-.776a4 4 0 003.139 3.139l-.776 3.924a8.039 8.039 0 003.122 0l-.776-3.924a4 4 0 003.139-3.139l3.924.776z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.652 3.555a8.043 8.043 0 00-2.207-2.208L10.22 4.671c.438.294.816.671 1.109 1.11l3.323-2.226zM1.347 12.445a8.043 8.043 0 002.208 2.207L5.78 11.33a4.042 4.042 0 01-1.109-1.11l-3.324 2.226zM12.445 14.652a8.042 8.042 0 002.207-2.207L11.33 10.22a4.04 4.04 0 01-1.11 1.109l2.226 3.323z","fill":"#fff"}})])
          )
        }
      }
    